export const close = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5891 18.0891C18.2634 18.4148 17.7363 18.4148 17.4106 18.0891L10.5 11.1785L3.58949 18.0891C3.26376 18.4148 2.73667 18.4148 2.41095 18.0891C2.08527 17.7634 2.08527 17.2363 2.41095 16.9106L9.32153 10L2.41095 3.08949C2.08527 2.76376 2.08527 2.23667 2.41095 1.91095C2.73667 1.58527 3.26376 1.58527 3.58949 1.91095L10.5 8.82153L17.4106 1.91095C17.7363 1.58527 18.2634 1.58527 18.5891 1.91095C18.9148 2.23667 18.9148 2.76376 18.5891 3.08949L11.6785 10L18.5891 16.9106C18.9148 17.2363 18.9148 17.7634 18.5891 18.0891Z"
      fill="black"
    />
    <mask
      id="mask0_4909_2440"
      maskUnits="userSpaceOnUse"
      x="2"
      y="1"
      width="17"
      height="18"
    >
      <path
        d="M18.5891 18.0891C18.2634 18.4148 17.7363 18.4148 17.4106 18.0891L10.5 11.1785L3.58949 18.0891C3.26376 18.4148 2.73667 18.4148 2.41095 18.0891C2.08527 17.7634 2.08527 17.2363 2.41095 16.9106L9.32153 10L2.41095 3.08949C2.08527 2.76376 2.08527 2.23667 2.41095 1.91095C2.73667 1.58527 3.26376 1.58527 3.58949 1.91095L10.5 8.82153L17.4106 1.91095C17.7363 1.58527 18.2634 1.58527 18.5891 1.91095C18.9148 2.23667 18.9148 2.76376 18.5891 3.08949L11.6785 10L18.5891 16.9106C18.9148 17.2363 18.9148 17.7634 18.5891 18.0891Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4909_2440)">
      <rect x="0.5" width="20" height="20" fill="black" />
    </g>
  </svg>
);

export const colouredAddCircle = (
  <svg
    width="15"
    height="16"
    viewBox="0 0 15 16"
    fill="#4D4D4D"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15 8C15 12.1431 11.6431 15.5 7.5 15.5C3.35685 15.5 0 12.1431 0 8C0 3.85685 3.35685 0.5 7.5 0.5C11.6431 0.5 15 3.85685 15 8ZM11.371 8.18145C11.371 8.38105 11.2077 8.54436 11.0081 8.54436H8.04436V11.5081C8.04436 11.7077 7.88105 11.871 7.68145 11.871H7.31855C7.11895 11.871 6.95565 11.7077 6.95565 11.5081V8.54436H3.99194C3.79234 8.54436 3.62903 8.38105 3.62903 8.18145V7.81855C3.62903 7.61895 3.79234 7.45565 3.99194 7.45565H6.95565V4.49194C6.95565 4.29234 7.11895 4.12903 7.31855 4.12903H7.68145C7.88105 4.12903 8.04436 4.29234 8.04436 4.49194V7.45565H11.0081C11.2077 7.45565 11.371 7.61895 11.371 7.81855V8.18145ZM7.5 1.46774C11.0897 1.46774 14.0323 4.37399 14.0323 8C14.0323 11.5897 11.126 14.5323 7.5 14.5323C3.91028 14.5323 0.967742 11.626 0.967742 8C0.967742 4.41028 3.87399 1.46774 7.5 1.46774Z"
      fill="#003A70"
    />
  </svg>
);

export const dropdown = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
  >
    <path
      d="M17.9055 8.35088L17.7145 8.11641C17.5881 7.9612 17.3837 7.9612 17.2573 8.11641L12.0015 14.5725L6.74304 8.11641C6.61663 7.9612 6.4122 7.9612 6.28579 8.11641L6.09481 8.35088C5.9684 8.50609 5.9684 8.75707 6.09481 8.91228L11.7702 15.8836C11.8966 16.0388 12.101 16.0388 12.2275 15.8836L17.9028 8.91228C18.0319 8.75707 18.0319 8.50609 17.9055 8.35088Z"
      fill="currentColor"
    />
    <mask
      id="mask0_4909_2420"
      maskUnits="userSpaceOnUse"
      x="6"
      y="8"
      width="12"
      height="8"
    >
      <path
        d="M17.9055 8.35088L17.7145 8.11641C17.5881 7.9612 17.3837 7.9612 17.2573 8.11641L12.0015 14.5725L6.74304 8.11641C6.61663 7.9612 6.4122 7.9612 6.28579 8.11641L6.09481 8.35088C5.9684 8.50609 5.9684 8.75707 6.09481 8.91228L11.7702 15.8836C11.8966 16.0388 12.101 16.0388 12.2275 15.8836L17.9028 8.91228C18.0319 8.75707 18.0319 8.50609 17.9055 8.35088Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4909_2420)">
      <rect width="24" height="24" fill="currentColor" />
    </g>
  </svg>
);

export const eye = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.99992 3.33325C10.8455 3.33325 13.3307 4.99043 14.586 7.43974C14.6934 7.65217 14.6934 7.90301 14.586 8.11544C13.3314 10.5638 10.8455 12.2222 7.99992 12.2222C5.15431 12.2222 2.66912 10.565 1.4138 8.11567C1.3064 7.90324 1.3064 7.6524 1.4138 7.43997C2.66843 4.99159 5.15431 3.33325 7.99992 3.33325ZM9.4814 7.03696C9.4814 7.85516 8.81812 8.51845 7.99992 8.51845C7.18172 8.51845 6.51844 7.85516 6.51844 7.03696C6.51844 7.02582 6.52009 7.01519 6.52175 7.00448L6.52175 7.00448C6.52344 6.9936 6.52515 6.98265 6.52515 6.97099C6.92652 7.11674 7.37598 7.01692 7.67793 6.71497C7.97987 6.41302 8.07969 5.96356 7.93395 5.56219C7.94385 5.56168 7.95335 5.56031 7.96285 5.55895C7.97491 5.55721 7.98698 5.55548 7.99992 5.55548C8.81812 5.55548 9.4814 6.21876 9.4814 7.03696ZM7.99992 4.07399C9.63632 4.07399 10.9629 5.40056 10.9629 7.03696C10.9629 8.67336 9.63632 9.99993 7.99992 9.99993C6.36352 9.99993 5.03695 8.67336 5.03695 7.03696C5.03874 5.4013 6.36426 4.07578 7.99992 4.07399ZM2.07398 7.77771C3.24389 10.0622 5.51473 11.4814 7.99992 11.4814C10.4851 11.4814 12.7562 10.0622 13.9259 7.77771C13.2679 6.48602 12.2157 5.43743 10.9217 4.78395C11.4048 5.40942 11.7036 6.18442 11.7036 7.03696C11.7036 9.08247 10.0454 10.7407 7.99992 10.7407C5.95442 10.7407 4.29621 9.08247 4.29621 7.03696C4.29621 6.18442 4.59505 5.40942 5.07816 4.78395C3.78419 5.43743 2.73196 6.48602 2.07398 7.77771Z"
      fill="#141414"
    />
    <mask
      id="mask0_5105_9721"
      maskUnits="userSpaceOnUse"
      x="1"
      y="3"
      width="14"
      height="10"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.99992 3.33325C10.8455 3.33325 13.3307 4.99043 14.586 7.43974C14.6934 7.65217 14.6934 7.90301 14.586 8.11544C13.3314 10.5638 10.8455 12.2222 7.99992 12.2222C5.15431 12.2222 2.66912 10.565 1.4138 8.11567C1.3064 7.90324 1.3064 7.6524 1.4138 7.43997C2.66843 4.99159 5.15431 3.33325 7.99992 3.33325ZM9.4814 7.03696C9.4814 7.85516 8.81812 8.51845 7.99992 8.51845C7.18172 8.51845 6.51844 7.85516 6.51844 7.03696C6.51844 7.02582 6.52009 7.01519 6.52175 7.00448L6.52175 7.00448C6.52344 6.9936 6.52515 6.98265 6.52515 6.97099C6.92652 7.11674 7.37598 7.01692 7.67793 6.71497C7.97987 6.41302 8.07969 5.96356 7.93395 5.56219C7.94385 5.56168 7.95335 5.56031 7.96285 5.55895C7.97491 5.55721 7.98698 5.55548 7.99992 5.55548C8.81812 5.55548 9.4814 6.21876 9.4814 7.03696ZM7.99992 4.07399C9.63632 4.07399 10.9629 5.40056 10.9629 7.03696C10.9629 8.67336 9.63632 9.99993 7.99992 9.99993C6.36352 9.99993 5.03695 8.67336 5.03695 7.03696C5.03874 5.4013 6.36426 4.07578 7.99992 4.07399ZM2.07398 7.77771C3.24389 10.0622 5.51473 11.4814 7.99992 11.4814C10.4851 11.4814 12.7562 10.0622 13.9259 7.77771C13.2679 6.48602 12.2157 5.43743 10.9217 4.78395C11.4048 5.40942 11.7036 6.18442 11.7036 7.03696C11.7036 9.08247 10.0454 10.7407 7.99992 10.7407C5.95442 10.7407 4.29621 9.08247 4.29621 7.03696C4.29621 6.18442 4.59505 5.40942 5.07816 4.78395C3.78419 5.43743 2.73196 6.48602 2.07398 7.77771Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5105_9721)">
      <rect width="16" height="16" fill="#262626" />
    </g>
  </svg>
);

export const clinicBuilding = (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.0833 17.6823V18.3334H2.5V17.6823C2.5 17.4666 2.6749 17.2917 2.89063 17.2917H3.54167V2.44794C3.54167 2.01646 3.89144 1.66669 4.32292 1.66669H15.2604C15.6919 1.66669 16.0417 2.01646 16.0417 2.44794V17.2917H16.6927C16.9084 17.2917 17.0833 17.4666 17.0833 17.6823ZM8.75 6.45184V5.14976C8.75 4.93404 8.5751 4.75914 8.35938 4.75914H7.05729C6.84157 4.75914 6.66667 4.93404 6.66667 5.14976V6.45184C6.66667 6.66757 6.84157 6.84247 7.05729 6.84247H8.35938C8.5751 6.84247 8.75 6.66757 8.75 6.45184ZM11.224 4.75914H12.526C12.7418 4.75914 12.9167 4.93404 12.9167 5.14976V6.45184C12.9167 6.66757 12.7418 6.84247 12.526 6.84247H11.224C11.0082 6.84247 10.8333 6.66757 10.8333 6.45184V5.14976C10.8333 4.93404 11.0082 4.75914 11.224 4.75914ZM8.35938 7.88413H7.05729C6.84157 7.88413 6.66667 8.05904 6.66667 8.27476V9.57684C6.66667 9.79257 6.84157 9.96747 7.05729 9.96747H8.35938C8.5751 9.96747 8.75 9.79257 8.75 9.57684V8.27476C8.75 8.05904 8.5751 7.88413 8.35938 7.88413ZM11.224 7.88413H12.526C12.7418 7.88413 12.9167 8.05904 12.9167 8.27476V9.57684C12.9167 9.79257 12.7418 9.96747 12.526 9.96747H11.224C11.0082 9.96747 10.8333 9.79257 10.8333 9.57684V8.27476C10.8333 8.05904 11.0082 7.88413 11.224 7.88413ZM8.35938 11.0091H7.05729C6.84157 11.0091 6.66667 11.184 6.66667 11.3998V12.7018C6.66667 12.9176 6.84157 13.0925 7.05729 13.0925H8.35938C8.5751 13.0925 8.75 12.9176 8.75 12.7018V11.3998C8.75 11.184 8.5751 11.0091 8.35938 11.0091ZM11.224 11.0091H12.526C12.7418 11.0091 12.9167 11.184 12.9167 11.3998V12.7018C12.9167 12.9176 12.7418 13.0925 12.526 13.0925H11.224C11.0082 13.0925 10.8333 12.9176 10.8333 12.7018V11.3998C10.8333 11.184 11.0082 11.0091 11.224 11.0091ZM15 2.70835V17.2917H10.8333V14.5248C10.8333 14.309 10.6584 14.1341 10.4427 14.1341H9.14062C8.9249 14.1341 8.75 14.309 8.75 14.5248V17.2917H4.58333V2.70835H15Z"
      fill="currentColor"
    />
    <mask
      id="mask0_4922_1753"
      maskUnits="userSpaceOnUse"
      x="2"
      y="1"
      width="16"
      height="18"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0833 17.6823V18.3334H2.5V17.6823C2.5 17.4666 2.6749 17.2917 2.89063 17.2917H3.54167V2.44794C3.54167 2.01646 3.89144 1.66669 4.32292 1.66669H15.2604C15.6919 1.66669 16.0417 2.01646 16.0417 2.44794V17.2917H16.6927C16.9084 17.2917 17.0833 17.4666 17.0833 17.6823ZM8.75 6.45184V5.14976C8.75 4.93404 8.5751 4.75914 8.35938 4.75914H7.05729C6.84157 4.75914 6.66667 4.93404 6.66667 5.14976V6.45184C6.66667 6.66757 6.84157 6.84247 7.05729 6.84247H8.35938C8.5751 6.84247 8.75 6.66757 8.75 6.45184ZM11.224 4.75914H12.526C12.7418 4.75914 12.9167 4.93404 12.9167 5.14976V6.45184C12.9167 6.66757 12.7418 6.84247 12.526 6.84247H11.224C11.0082 6.84247 10.8333 6.66757 10.8333 6.45184V5.14976C10.8333 4.93404 11.0082 4.75914 11.224 4.75914ZM8.35938 7.88413H7.05729C6.84157 7.88413 6.66667 8.05904 6.66667 8.27476V9.57684C6.66667 9.79257 6.84157 9.96747 7.05729 9.96747H8.35938C8.5751 9.96747 8.75 9.79257 8.75 9.57684V8.27476C8.75 8.05904 8.5751 7.88413 8.35938 7.88413ZM11.224 7.88413H12.526C12.7418 7.88413 12.9167 8.05904 12.9167 8.27476V9.57684C12.9167 9.79257 12.7418 9.96747 12.526 9.96747H11.224C11.0082 9.96747 10.8333 9.79257 10.8333 9.57684V8.27476C10.8333 8.05904 11.0082 7.88413 11.224 7.88413ZM8.35938 11.0091H7.05729C6.84157 11.0091 6.66667 11.184 6.66667 11.3998V12.7018C6.66667 12.9176 6.84157 13.0925 7.05729 13.0925H8.35938C8.5751 13.0925 8.75 12.9176 8.75 12.7018V11.3998C8.75 11.184 8.5751 11.0091 8.35938 11.0091ZM11.224 11.0091H12.526C12.7418 11.0091 12.9167 11.184 12.9167 11.3998V12.7018C12.9167 12.9176 12.7418 13.0925 12.526 13.0925H11.224C11.0082 13.0925 10.8333 12.9176 10.8333 12.7018V11.3998C10.8333 11.184 11.0082 11.0091 11.224 11.0091ZM15 2.70835V17.2917H10.8333V14.5248C10.8333 14.309 10.6584 14.1341 10.4427 14.1341H9.14062C8.9249 14.1341 8.75 14.309 8.75 14.5248V17.2917H4.58333V2.70835H15Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4922_1753)">
      <rect width="20" height="20" fill="currentColor" />
    </g>
  </svg>
);

export const KeyIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-6 w-6"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"
    />
  </svg>
);

export const errorIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="15" fill="#FFB5B5" />
    <circle cx="15" cy="15" r="9" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 15C5 9.47915 9.47754 5 15 5C20.5225 5 25 9.47915 25 15C25 20.5241 20.5225 25 15 25C9.47754 25 5 20.5241 5 15ZM23.7097 15C23.7097 10.1643 19.7831 6.29032 15 6.29032C10.1856 6.29032 6.29032 10.1934 6.29032 15C6.29032 19.816 10.1918 23.7097 15 23.7097C19.8141 23.7097 23.7097 19.8101 23.7097 15ZM14.5367 9.83871H15.4633C15.7384 9.83871 15.9582 10.0678 15.9467 10.3427L15.6645 17.1169C15.6537 17.3761 15.4404 17.5806 15.181 17.5806H14.819C14.5596 17.5806 14.3463 17.3761 14.3355 17.1169L14.0532 10.3427C14.0418 10.0678 14.2616 9.83871 14.5367 9.83871ZM13.871 19.5161C13.871 18.8926 14.3765 18.3871 15 18.3871C15.6235 18.3871 16.129 18.8926 16.129 19.5161C16.129 20.1397 15.6235 20.6452 15 20.6452C14.3765 20.6452 13.871 20.1397 13.871 19.5161Z"
      fill="black"
    />
    <mask
      id="mask0_5154_10121"
      style={{ maskType: "alpha" }}
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="5"
      y="5"
      width="20"
      height="20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 15C5 9.47915 9.47754 5 15 5C20.5225 5 25 9.47915 25 15C25 20.5241 20.5225 25 15 25C9.47754 25 5 20.5241 5 15ZM23.7097 15C23.7097 10.1643 19.7831 6.29032 15 6.29032C10.1856 6.29032 6.29032 10.1934 6.29032 15C6.29032 19.816 10.1918 23.7097 15 23.7097C19.8141 23.7097 23.7097 19.8101 23.7097 15ZM14.5367 9.83871H15.4633C15.7384 9.83871 15.9582 10.0678 15.9467 10.3427L15.6645 17.1169C15.6537 17.3761 15.4404 17.5806 15.181 17.5806H14.819C14.5596 17.5806 14.3463 17.3761 14.3355 17.1169L14.0532 10.3427C14.0418 10.0678 14.2616 9.83871 14.5367 9.83871ZM13.871 19.5161C13.871 18.8926 14.3765 18.3871 15 18.3871C15.6235 18.3871 16.129 18.8926 16.129 19.5161C16.129 20.1397 15.6235 20.6452 15 20.6452C14.3765 20.6452 13.871 20.1397 13.871 19.5161Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5154_10121)">
      <rect x="3" y="3" width="24" height="24" fill="#E60000" />
    </g>
  </svg>
);

export const infoIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="15" fill="#C5E3FF" />
    <circle cx="15" cy="15" r="9" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 15C5 9.47915 9.47754 5 15 5C20.5225 5 25 9.47915 25 15C25 20.5241 20.5225 25 15 25C9.47754 25 5 20.5241 5 15ZM23.7097 15C23.7097 10.1643 19.7831 6.29032 15 6.29032C10.1856 6.29032 6.29032 10.1934 6.29032 15C6.29032 19.816 10.1918 23.7097 15 23.7097C19.8141 23.7097 23.7097 19.8101 23.7097 15ZM13.5484 18.871H14.0323V14.0323H13.5484C13.2812 14.0323 13.0645 13.8156 13.0645 13.5484V13.2258C13.0645 12.9586 13.2812 12.7419 13.5484 12.7419H15.4839C15.7511 12.7419 15.9677 12.9586 15.9677 13.2258V18.871H16.4516C16.7188 18.871 16.9355 19.0876 16.9355 19.3548V19.6774C16.9355 19.9446 16.7188 20.1613 16.4516 20.1613H13.5484C13.2812 20.1613 13.0645 19.9446 13.0645 19.6774V19.3548C13.0645 19.0876 13.2812 18.871 13.5484 18.871ZM13.7097 10.4839C13.7097 9.77125 14.2874 9.19355 15 9.19355C15.7126 9.19355 16.2903 9.77125 16.2903 10.4839C16.2903 11.1965 15.7126 11.7742 15 11.7742C14.2874 11.7742 13.7097 11.1965 13.7097 10.4839Z"
      fill="#40A9FF"
    />
    <mask
      id="mask0_1632_10021"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="5"
      width="20"
      height="20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 15C5 9.47915 9.47754 5 15 5C20.5225 5 25 9.47915 25 15C25 20.5241 20.5225 25 15 25C9.47754 25 5 20.5241 5 15ZM23.7097 15C23.7097 10.1643 19.7831 6.29032 15 6.29032C10.1856 6.29032 6.29032 10.1934 6.29032 15C6.29032 19.816 10.1918 23.7097 15 23.7097C19.8141 23.7097 23.7097 19.8101 23.7097 15ZM13.5484 18.871H14.0323V14.0323H13.5484C13.2812 14.0323 13.0645 13.8156 13.0645 13.5484V13.2258C13.0645 12.9586 13.2812 12.7419 13.5484 12.7419H15.4839C15.7511 12.7419 15.9677 12.9586 15.9677 13.2258V18.871H16.4516C16.7188 18.871 16.9355 19.0876 16.9355 19.3548V19.6774C16.9355 19.9446 16.7188 20.1613 16.4516 20.1613H13.5484C13.2812 20.1613 13.0645 19.9446 13.0645 19.6774V19.3548C13.0645 19.0876 13.2812 18.871 13.5484 18.871ZM13.7097 10.4839C13.7097 9.77125 14.2874 9.19355 15 9.19355C15.7126 9.19355 16.2903 9.77125 16.2903 10.4839C16.2903 11.1965 15.7126 11.7742 15 11.7742C14.2874 11.7742 13.7097 11.1965 13.7097 10.4839Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1632_10021)">
      <rect x="3" y="3" width="24" height="24" fill="#40A9FF" />
    </g>
  </svg>
);

export const successIcon = (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="15" cy="15" r="15" fill="#B2E6D2" />
    <circle cx="15" cy="15" r="9" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 15C5 9.47915 9.47754 5 15 5C20.5225 5 25 9.47915 25 15C25 20.5241 20.5225 25 15 25C9.47754 25 5 20.5241 5 15ZM23.7097 15C23.7097 10.1643 19.7831 6.29032 15 6.29032C10.1856 6.29032 6.29032 10.1934 6.29032 15C6.29032 19.816 10.1918 23.7097 15 23.7097C19.8141 23.7097 23.7097 19.8101 23.7097 15Z"
      fill="black"
    />
    <mask
      id="mask0_1632_9942"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="5"
      y="5"
      width="20"
      height="20"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5 15C5 9.47915 9.47754 5 15 5C20.5225 5 25 9.47915 25 15C25 20.5241 20.5225 25 15 25C9.47754 25 5 20.5241 5 15ZM23.7097 15C23.7097 10.1643 19.7831 6.29032 15 6.29032C10.1856 6.29032 6.29032 10.1934 6.29032 15C6.29032 19.816 10.1918 23.7097 15 23.7097C19.8141 23.7097 23.7097 19.8101 23.7097 15Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_1632_9942)">
      <rect x="3" y="3" width="24" height="24" fill="#28B980" />
    </g>
    <path
      d="M10.2255 15.4881L13.7006 18.9501L19.8988 11.6431"
      stroke="#28B980"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const document = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
    />
  </svg>
);

export const folder = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
    />
  </svg>
);

export const trash = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0"
    />
  </svg>
);

export const fileCode = (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4820_23309)">
      <path
        d="M8.33866 9.57277C8.16573 9.39984 7.88544 9.39984 7.71278 9.57277L6.38466 10.9009C6.21173 11.0738 6.21173 11.3541 6.38466 11.5268L7.71278 12.8549C7.79911 12.9401 7.91256 12.9844 8.026 12.9844C8.13945 12.9844 8.25256 12.9412 8.33894 12.8547C8.51187 12.6817 8.51187 12.4015 8.33894 12.2288L7.3232 11.2136L8.33839 10.1984C8.51298 10.0266 8.51298 9.74432 8.33866 9.57277ZM14.1492 5.38365L11.2024 2.43687C10.8676 2.10323 10.4194 1.91669 9.94902 1.91669H5.81246C4.83435 1.91669 4.04163 2.70969 4.04163 3.68752L4.04181 14.3125C4.04181 15.2904 4.83453 16.0834 5.81264 16.0834H12.8958C13.8739 16.0834 14.6666 15.2904 14.6666 14.3125V6.6343C14.6666 6.16392 14.4812 5.71568 14.1492 5.38365ZM10.2395 2.85966C10.3634 2.90288 10.4793 2.96602 10.5749 3.06156L13.5217 6.00834C13.618 6.10305 13.6816 6.21926 13.7231 6.34377H10.6823C10.4388 6.34377 10.2395 6.14455 10.2395 5.90106V2.85966ZM13.7812 14.3125C13.7812 14.8006 13.3839 15.1979 12.8958 15.1979H5.81246C5.32437 15.1979 4.92704 14.8006 4.92704 14.3125V3.68752C4.92704 3.19943 5.32437 2.8021 5.81246 2.8021H9.35413V5.90106C9.35413 6.6343 9.94902 7.22919 10.6823 7.22919H13.7812V14.3125ZM10.3696 10.1981L11.3851 11.2136L10.3699 12.2287C10.1969 12.4017 10.1969 12.682 10.3699 12.8546C10.4554 12.9401 10.5688 12.9844 10.6823 12.9844C10.7957 12.9844 10.9088 12.9412 10.9952 12.8547L12.3233 11.5266C12.4962 11.3536 12.4962 11.0733 12.3233 10.9007L10.9952 9.57255C10.8223 9.39962 10.542 9.39962 10.3693 9.57255C10.1967 9.74549 10.1953 10.0265 10.3696 10.1981Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_4820_23309">
        <rect
          width="10.625"
          height="14.1667"
          fill="white"
          transform="translate(4.04163 1.91669)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const arrow = (
  <svg
    width="6"
    height="12"
    viewBox="0 0 6 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6 0L6 6L6 12L-2.62268e-07 6L6 0Z" fill="currentColor" />
  </svg>
);

export const lock = (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.3333 26.8331V16.8332C27.3333 15.453 26.2135 14.3332 24.8333 14.3332H23.9999V11.078C23.9999 6.47383 20.2968 2.68218 15.6927 2.66655C11.0833 2.65093 7.33332 6.39571 7.33332 10.9999V14.3332H6.49999C5.11979 14.3332 4 15.453 4 16.8332V26.8331C4 28.2133 5.11979 29.3331 6.49999 29.3331H24.8333C26.2135 29.3331 27.3333 28.2133 27.3333 26.8331ZM14.625 23.4998C14.625 24.0727 15.0937 24.5415 15.6666 24.5415C16.2395 24.5415 16.7083 24.0727 16.7083 23.4998V20.1665C16.7083 19.5936 16.2395 19.1248 15.6666 19.1248C15.0937 19.1248 14.625 19.5936 14.625 20.1665V23.4998ZM22.3333 14.3332V10.9999C22.3333 7.3228 19.3437 4.33323 15.6666 4.33323C11.9896 4.33323 8.99998 7.3228 8.99998 10.9999V14.3332H22.3333ZM25.6666 16.8332V26.8331C25.6666 27.2915 25.2916 27.6665 24.8333 27.6665H6.49999C6.04166 27.6665 5.66666 27.2915 5.66666 26.8331V16.8332C5.66666 16.3748 6.04166 15.9998 6.49999 15.9998H24.8333C25.2916 15.9998 25.6666 16.3748 25.6666 16.8332Z"
      fill="black"
    />
    <mask
      id="mask0_5227_4892"
      style={{ maskType: "alpha" }}
      // style="mask-type:alpha"
      maskUnits="userSpaceOnUse"
      x="4"
      y="2"
      width="24"
      height="28"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.3333 26.8331V16.8332C27.3333 15.453 26.2135 14.3332 24.8333 14.3332H23.9999V11.078C23.9999 6.47383 20.2968 2.68218 15.6927 2.66655C11.0833 2.65093 7.33332 6.39571 7.33332 10.9999V14.3332H6.49999C5.11979 14.3332 4 15.453 4 16.8332V26.8331C4 28.2133 5.11979 29.3331 6.49999 29.3331H24.8333C26.2135 29.3331 27.3333 28.2133 27.3333 26.8331ZM14.625 23.4998C14.625 24.0727 15.0937 24.5415 15.6666 24.5415C16.2395 24.5415 16.7083 24.0727 16.7083 23.4998V20.1665C16.7083 19.5936 16.2395 19.1248 15.6666 19.1248C15.0937 19.1248 14.625 19.5936 14.625 20.1665V23.4998ZM22.3333 14.3332V10.9999C22.3333 7.3228 19.3437 4.33323 15.6666 4.33323C11.9896 4.33323 8.99998 7.3228 8.99998 10.9999V14.3332H22.3333ZM25.6666 16.8332V26.8331C25.6666 27.2915 25.2916 27.6665 24.8333 27.6665H6.49999C6.04166 27.6665 5.66666 27.2915 5.66666 26.8331V16.8332C5.66666 16.3748 6.04166 15.9998 6.49999 15.9998H24.8333C25.2916 15.9998 25.6666 16.3748 25.6666 16.8332Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_5227_4892)">
      <rect width="32" height="32" fill="#0074E0" />
    </g>
  </svg>
);

export const BiIconCheck = (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.91875 10.6863L2.56031 7.52545L1.41667 8.59424L5.91875 12.8315L15.5833 3.73541L14.4477 2.66663L5.91875 10.6863Z"
      fill="currentColor"
    />
    <mask
      id="mask0_4729_68501"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="1"
      y="2"
      width="15"
      height="11"
    >
      <path
        d="M5.91875 10.6863L2.56031 7.52545L1.41667 8.59424L5.91875 12.8315L15.5833 3.73541L14.4477 2.66663L5.91875 10.6863Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_4729_68501)">
      <rect width="17" height="16" fill="currentColor" />
    </g>
  </svg>
);

export const poweredByBI = (
  <svg
    width="250"
    height="60"
    viewBox="0 0 250 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.54 33V30.063H23.575C24.961 30.063 25.973 29.04 25.973 27.687C25.973 26.323 24.961 25.3 23.575 25.3H20.957V33H21.54ZM23.575 29.513H21.54V25.85H23.575C24.631 25.85 25.39 26.62 25.39 27.687C25.39 28.743 24.631 29.513 23.575 29.513ZM32.705 30.25C32.705 31.878 31.418 33.121 29.823 33.121C28.217 33.121 26.93 31.878 26.93 30.25C26.93 28.622 28.217 27.379 29.823 27.379C31.418 27.379 32.705 28.622 32.705 30.25ZM29.823 32.593C28.514 32.593 27.491 31.559 27.491 30.25C27.491 28.941 28.514 27.907 29.823 27.907C31.132 27.907 32.144 28.941 32.144 30.25C32.144 31.559 31.132 32.593 29.823 32.593ZM37.413 28.314L35.884 33H35.279L33.541 27.5H34.124L35.587 32.285L37.127 27.5H37.699L39.239 32.285L40.702 27.5H41.285L39.547 33H38.942L37.413 28.314ZM45.014 33.121C46.103 33.121 46.961 32.626 47.412 31.878L46.928 31.592C46.609 32.175 45.927 32.593 45.025 32.593C43.771 32.593 42.825 31.779 42.693 30.536H47.676C47.676 30.492 47.6788 30.448 47.6815 30.404C47.6843 30.36 47.687 30.316 47.687 30.272C47.687 28.765 46.642 27.379 44.97 27.379C43.287 27.379 42.121 28.633 42.121 30.25C42.121 31.911 43.32 33.121 45.014 33.121ZM42.693 29.997H47.115C46.994 28.655 46.048 27.907 44.97 27.907C43.716 27.907 42.803 28.776 42.693 29.997ZM49.524 33V29.942C49.524 28.534 50.415 27.951 51.361 27.951V27.423C50.613 27.423 49.898 27.709 49.524 28.578V27.5H48.974V33H49.524ZM57.389 31.878C56.938 32.626 56.08 33.121 54.991 33.121C53.297 33.121 52.098 31.911 52.098 30.25C52.098 28.633 53.264 27.379 54.947 27.379C56.619 27.379 57.664 28.765 57.664 30.272L57.653 30.536H52.67C52.802 31.779 53.748 32.593 55.002 32.593C55.904 32.593 56.586 32.175 56.905 31.592L57.389 31.878ZM57.092 29.997H52.67C52.78 28.776 53.693 27.907 54.947 27.907C56.025 27.907 56.971 28.655 57.092 29.997ZM63.802 31.724C63.351 32.571 62.504 33.121 61.437 33.121C59.864 33.121 58.588 31.878 58.588 30.25C58.588 28.622 59.864 27.379 61.437 27.379C62.504 27.379 63.351 27.929 63.802 28.776V25.3H64.352V33H63.802V31.724ZM61.47 32.593C60.161 32.593 59.138 31.559 59.138 30.25C59.138 28.941 60.161 27.907 61.47 27.907C62.779 27.907 63.802 28.941 63.802 30.25C63.802 31.559 62.779 32.593 61.47 32.593ZM74.747 30.25C74.747 31.878 73.471 33.121 71.898 33.121C70.831 33.121 69.984 32.571 69.533 31.724V33H68.983V25.3H69.533V28.776C69.984 27.929 70.831 27.379 71.898 27.379C73.471 27.379 74.747 28.622 74.747 30.25ZM71.865 32.593C70.556 32.593 69.533 31.559 69.533 30.25C69.533 28.941 70.556 27.907 71.865 27.907C73.174 27.907 74.197 28.941 74.197 30.25C74.197 31.559 73.174 32.593 71.865 32.593ZM80.698 27.5L78.322 33.506C77.904 34.562 77.09 35.277 76.144 35.2V34.683C76.881 34.749 77.442 34.199 77.783 33.396L77.904 33.099L75.374 27.5H75.968L78.19 32.395L80.104 27.5H80.698Z"
      fill="white"
    />
    <path
      d="M184.406 21.1819H182.942L185.632 26.2152L182.935 31.3337H184.394L187.094 26.2107L184.406 21.1819Z"
      fill="#00AC69"
    />
    <path
      d="M193.307 21.1819H190.983L194.522 26.2937L190.917 31.3337H193.266L196.858 26.3116L193.307 21.1819Z"
      fill="white"
    />
    <path
      d="M180.687 21.1819H179.761L182.309 26.2195L179.76 31.3337H180.683L183.234 26.2165L180.687 21.1819Z"
      fill="#BEDE18"
    />
    <path
      d="M188.431 21.1819H186.695L189.813 26.2157L186.688 31.3337H188.417L191.546 26.2101L188.431 21.1819Z"
      fill="#007179"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M94.9521 30.8123C94.9521 32.4215 93.5722 33.7179 91.8592 33.7179H87.0212V23.2871H91.4942C93.1438 23.2871 94.4764 24.5537 94.4764 26.0886C94.4764 27.057 93.9688 27.8468 93.1755 28.309C94.2225 28.7261 94.9521 29.6501 94.9521 30.8123ZM88.1316 24.2707V27.9065H91.4942C92.5252 27.9065 93.3661 27.1018 93.3661 26.0886C93.3661 25.0901 92.5252 24.2707 91.4942 24.2707H88.1316ZM91.8592 28.8901C92.9538 28.8901 93.8418 29.7542 93.8418 30.8123C93.8418 31.8851 92.9538 32.7345 91.8592 32.7345H88.1316V28.8901H91.8592Z"
      fill="white"
    />
    <path
      d="M100.25 26.1482V27.1017C98.9808 27.1017 97.7435 27.7276 97.7435 29.5755V33.7179H96.6965V26.2675H97.7435V27.5042C98.2985 26.461 99.2345 26.1482 100.25 26.1482Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M102.201 23.2571C101.772 23.2571 101.439 23.585 101.439 23.9724C101.439 24.3597 101.772 24.6876 102.201 24.6876C102.629 24.6876 102.962 24.3597 102.962 23.9724C102.962 23.585 102.629 23.2571 102.201 23.2571ZM102.724 33.7174V26.2673H101.677V33.7174H102.724Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M112.812 33.4198V26.2673H111.765V27.7274C111.099 26.7291 109.972 26.0884 108.561 26.0884C106.324 26.0884 104.469 27.787 104.469 29.9925C104.469 32.1979 106.324 33.8963 108.561 33.8963C109.972 33.8963 111.099 33.2558 111.765 32.2573V33.4198C111.765 34.9398 110.67 35.9229 108.83 35.9229C107.117 35.9229 106.388 35.3268 105.991 34.5668L105.071 35.0588C105.69 36.2213 107.006 36.8769 108.83 36.8769C110.877 36.8769 112.812 35.6846 112.812 33.4198ZM108.64 27.0419C110.401 27.0419 111.765 28.3383 111.765 29.9925C111.765 31.6464 110.401 32.9428 108.64 32.9428C106.879 32.9428 105.515 31.6464 105.515 29.9925C105.515 28.3383 106.879 27.0419 108.64 27.0419Z"
      fill="white"
    />
    <path
      d="M121.853 29.1432V33.7179H120.806V29.1432C120.806 27.817 120.029 27.0421 118.649 27.0421C117.253 27.0421 116.079 27.817 116.079 29.8138V33.7179H115.032V23.2871H116.079V27.4297C116.698 26.4908 117.618 26.0886 118.744 26.0886C120.679 26.0886 121.853 27.2806 121.853 29.1432Z"
      fill="white"
    />
    <path
      d="M125.802 27.2209V31.7359C125.802 33.0171 126.548 32.9133 128.086 32.8537V33.7178C125.945 34.0162 124.755 33.5242 124.755 31.7362V27.2209H123.09V26.2674H124.755V24.479L125.802 24.1812V26.2674H128.086V27.2209H125.802Z"
      fill="white"
    />
    <path d="M131.893 23.2871V33.7176H130.782V23.2871H131.893Z" fill="white" />
    <path
      d="M141.093 29.143V33.7177H140.045V29.143C140.045 27.8168 139.269 27.0419 137.888 27.0419C136.492 27.0419 135.319 27.8168 135.319 29.8136V33.7177H134.272V26.2673H135.319V27.4295C135.937 26.4906 136.857 26.0884 137.983 26.0884C139.919 26.0884 141.093 27.2804 141.093 29.143Z"
      fill="white"
    />
    <path
      d="M148.579 31.7507C148.579 33.017 147.405 33.8963 145.708 33.8963C144.122 33.8963 143.043 33.1366 142.647 32.183L143.535 31.6911C143.821 32.4511 144.645 32.9428 145.708 32.9428C146.644 32.9428 147.533 32.63 147.533 31.7507C147.533 29.903 142.901 30.9609 142.901 28.2193C142.901 27.027 144.027 26.0884 145.614 26.0884C146.914 26.0884 147.929 26.6844 148.389 27.6084L147.517 28.0851C147.183 27.3251 146.375 27.0419 145.614 27.0419C144.788 27.0419 143.948 27.4146 143.948 28.2193C143.948 30.067 148.579 29.0089 148.579 31.7507Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M150.768 23.2571C150.34 23.2571 150.007 23.585 150.007 23.9724C150.007 24.3597 150.34 24.6876 150.768 24.6876C151.196 24.6876 151.529 24.3597 151.529 23.9724C151.529 23.585 151.196 23.2571 150.768 23.2571ZM151.292 26.2673H150.244V33.7174H151.292V26.2673Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M161.379 33.4198V26.2673H160.332V27.7274C159.666 26.7291 158.54 26.0884 157.128 26.0884C154.891 26.0884 153.036 27.787 153.036 29.9925C153.036 32.1979 154.891 33.8963 157.128 33.8963C158.54 33.8963 159.666 33.2558 160.332 32.2573V33.4198C160.332 34.9398 159.238 35.9229 157.398 35.9229C155.685 35.9229 154.955 35.3268 154.559 34.5668L153.639 35.0588C154.257 36.2213 155.574 36.8769 157.398 36.8769C159.444 36.8769 161.379 35.6846 161.379 33.4198ZM157.208 27.0419C158.969 27.0419 160.332 28.3383 160.332 29.9925C160.332 31.6464 158.969 32.9428 157.208 32.9428C155.447 32.9428 154.083 31.6464 154.083 29.9925C154.083 28.3383 155.447 27.0419 157.208 27.0419Z"
      fill="white"
    />
    <path
      d="M170.42 29.1432V33.7179H169.373V29.1432C169.373 27.817 168.596 27.0421 167.216 27.0421C165.82 27.0421 164.646 27.817 164.646 29.8138V33.7179H163.599V23.2871H164.646V27.4297C165.265 26.4908 166.185 26.0886 167.311 26.0886C169.246 26.0886 170.42 27.2806 170.42 29.1432Z"
      fill="white"
    />
    <path
      d="M174.369 27.2209V31.7359C174.369 33.0171 175.115 32.9133 176.653 32.8537V33.7178C174.512 34.0162 173.322 33.5242 173.322 31.7362V27.2209H171.656V26.2674H173.322V24.479L174.369 24.1812V26.2674H176.653V27.2209H174.369Z"
      fill="white"
    />
  </svg>
);

export const alert = (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5289_10448)">
      <path
        d="M14.3423 11.4726C14.7909 12.2502 14.2278 13.2223 13.3318 13.2223H1.66786C0.77009 13.2223 0.209555 12.2487 0.657312 11.4726L6.48933 1.3608C6.93818 0.582804 8.06239 0.584214 8.51044 1.3608L14.3423 11.4726ZM7.49988 9.382C6.8824 9.382 6.38183 9.88257 6.38183 10.5001C6.38183 11.1175 6.8824 11.6181 7.49988 11.6181C8.11737 11.6181 8.61794 11.1175 8.61794 10.5001C8.61794 9.88257 8.11737 9.382 7.49988 9.382ZM6.43839 5.36317L6.61869 8.66873C6.62712 8.82341 6.75502 8.9445 6.90991 8.9445H8.08985C8.24475 8.9445 8.37265 8.82341 8.38108 8.66873L8.56138 5.36317C8.57049 5.1961 8.43747 5.05561 8.27015 5.05561H6.72959C6.56227 5.05561 6.42927 5.1961 6.43839 5.36317Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5289_10448">
        <rect
          width="14"
          height="12.4444"
          fill="white"
          transform="translate(0.5 0.777832)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const hamMenuRight = (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.32288 4.6726H13.677C13.7633 4.6726 13.8333 4.57266 13.8333 4.44938V3.55653C13.8333 3.43325 13.7633 3.33331 13.677 3.33331H2.32288C2.23658 3.33331 2.16663 3.43325 2.16663 3.55653V4.44938C2.16663 4.57266 2.23658 4.6726 2.32288 4.6726ZM16.1786 9.28569L15.8758 7.88693C15.8241 7.64817 16.1103 7.48462 16.2898 7.65039L18.6345 9.81635C18.7416 9.91533 18.7416 10.0846 18.6345 10.1836L16.2898 12.3496C16.1103 12.5153 15.8241 12.3518 15.8758 12.113L16.198 10.625H2.36752C2.25657 10.625 2.16663 10.525 2.16663 10.4018V9.50891C2.16663 9.38563 2.25657 9.28569 2.36752 9.28569H16.1786ZM13.677 16.5774H2.32288C2.23658 16.5774 2.16663 16.4774 2.16663 16.3541V15.4613C2.16663 15.338 2.23658 15.2381 2.32288 15.2381H13.677C13.7633 15.2381 13.8333 15.338 13.8333 15.4613V16.3541C13.8333 16.4774 13.7633 16.5774 13.677 16.5774Z"
      fill="white"
    />
  </svg>
);

export const PatientRequest = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 3C6.47734 3 2 6.68946 2 11.2411C2 13.2047 2.83633 15.005 4.22656 16.4211C3.73672 18.4144 2.10547 20.1953 2.08594 20.2151C2.04397 20.2601 2.0159 20.3165 2.0052 20.3775C1.99451 20.4385 2.00165 20.5013 2.02575 20.5582C2.04985 20.615 2.08984 20.6635 2.1408 20.6976C2.19176 20.7317 2.25145 20.7499 2.3125 20.75C4.90078 20.75 6.84375 19.492 7.80469 18.7143C9.14616 19.2243 10.5674 19.4844 12 19.4821C17.523 19.4821 22 15.7927 22 11.2411C22 6.68946 17.523 3 12 3ZM15.75 12.192C15.75 12.276 15.7171 12.3567 15.6585 12.4161C15.5999 12.4755 15.5204 12.5089 15.4375 12.5089H13.25V14.7277C13.25 14.8117 13.2171 14.8924 13.1585 14.9518C13.0999 15.0112 13.0204 15.0446 12.9375 15.0446H11.0625C10.9796 15.0446 10.9001 15.0112 10.8415 14.9518C10.7829 14.8924 10.75 14.8117 10.75 14.7277V12.5089H8.5625C8.47962 12.5089 8.40013 12.4755 8.34153 12.4161C8.28292 12.3567 8.25 12.276 8.25 12.192V10.2902C8.25 10.2061 8.28292 10.1255 8.34153 10.0661C8.40013 10.0066 8.47962 9.97321 8.5625 9.97321H10.75V7.75446C10.75 7.6704 10.7829 7.58978 10.8415 7.53034C10.9001 7.47089 10.9796 7.4375 11.0625 7.4375H12.9375C13.0204 7.4375 13.0999 7.47089 13.1585 7.53034C13.2171 7.58978 13.25 7.6704 13.25 7.75446V9.97321H15.4375C15.5204 9.97321 15.5999 10.0066 15.6585 10.0661C15.7171 10.1255 15.75 10.2061 15.75 10.2902V12.192Z"
      fill="currentColor"
    />
  </svg>
);

export const createRequest = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C6.47581 2 2 6.47581 2 12C2 17.5242 6.47581 22 12 22C17.5242 22 22 17.5242 22 12C22 6.47581 17.5242 2 12 2ZM17.8065 13.129C17.8065 13.3952 17.5887 13.6129 17.3226 13.6129H13.6129V17.3226C13.6129 17.5887 13.3952 17.8065 13.129 17.8065H10.871C10.6048 17.8065 10.3871 17.5887 10.3871 17.3226V13.6129H6.67742C6.41129 13.6129 6.19355 13.3952 6.19355 13.129V10.871C6.19355 10.6048 6.41129 10.3871 6.67742 10.3871H10.3871V6.67742C10.3871 6.41129 10.6048 6.19355 10.871 6.19355H13.129C13.3952 6.19355 13.6129 6.41129 13.6129 6.67742V10.3871H17.3226C17.5887 10.3871 17.8065 10.6048 17.8065 10.871V13.129Z"
      fill="currentColor"
    />
  </svg>
);

export const requestHistory = (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22 11.9811C22.0102 17.4908 17.517 21.9961 12.0073 22C9.62763 22.0017 7.44182 21.1722 5.72412 19.7858C5.27747 19.4254 5.24408 18.756 5.64997 18.3501L6.10428 17.8958C6.45142 17.5486 7.00561 17.5106 7.39021 17.8158C8.65574 18.82 10.2573 19.4194 12 19.4194C16.101 19.4194 19.4194 16.1004 19.4194 12C19.4194 7.899 16.1004 4.58065 12 4.58065C10.0317 4.58065 8.244 5.34553 6.91662 6.59404L8.96316 8.64058C9.36961 9.04703 9.08175 9.74195 8.50699 9.74195H2.64516C2.28883 9.74195 2 9.45312 2 9.09679V3.23496C2 2.6602 2.69492 2.37234 3.10137 2.77875L5.09218 4.76956C6.88747 3.05387 9.32066 2 12 2C17.5166 2 21.9898 6.46694 22 11.9811ZM14.7052 15.1579L15.1013 14.6486C15.4294 14.2267 15.3534 13.6187 14.9315 13.2906L13.2903 12.0141V7.80646C13.2903 7.27199 12.8571 6.83872 12.3226 6.83872H11.6774C11.143 6.83872 10.7097 7.27199 10.7097 7.80646V13.2763L13.3472 15.3276C13.7691 15.6558 14.377 15.5798 14.7052 15.1579Z"
      fill="currentColor"
    />
  </svg>
);

export const SettingIcon = (
  <svg
    width="20"
    height="22"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
  >
    <path
      d="M512.1 191l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0L552 6.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zm-10.5-58.8c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.7-82.4 14.3-52.8 52.8zM386.3 286.1l33.7 16.8c10.1 5.8 14.5 18.1 10.5 29.1-8.9 24.2-26.4 46.4-42.6 65.8-7.4 8.9-20.2 11.1-30.3 5.3l-29.1-16.8c-16 13.7-34.6 24.6-54.9 31.7v33.6c0 11.6-8.3 21.6-19.7 23.6-24.6 4.2-50.4 4.4-75.9 0-11.5-2-20-11.9-20-23.6V418c-20.3-7.2-38.9-18-54.9-31.7L74 403c-10 5.8-22.9 3.6-30.3-5.3-16.2-19.4-33.3-41.6-42.2-65.7-4-10.9.4-23.2 10.5-29.1l33.3-16.8c-3.9-20.9-3.9-42.4 0-63.4L12 205.8c-10.1-5.8-14.6-18.1-10.5-29 8.9-24.2 26-46.4 42.2-65.8 7.4-8.9 20.2-11.1 30.3-5.3l29.1 16.8c16-13.7 34.6-24.6 54.9-31.7V57.1c0-11.5 8.2-21.5 19.6-23.5 24.6-4.2 50.5-4.4 76-.1 11.5 2 20 11.9 20 23.6v33.6c20.3 7.2 38.9 18 54.9 31.7l29.1-16.8c10-5.8 22.9-3.6 30.3 5.3 16.2 19.4 33.2 41.6 42.1 65.8 4 10.9.1 23.2-10 29.1l-33.7 16.8c3.9 21 3.9 42.5 0 63.5zm-117.6 21.1c59.2-77-28.7-164.9-105.7-105.7-59.2 77 28.7 164.9 105.7 105.7zm243.4 182.7l-8.2 14.3c-3 5.3-9.4 7.5-15.1 5.4-11.8-4.4-22.6-10.7-32.1-18.6-4.6-3.8-5.8-10.5-2.8-15.7l8.2-14.3c-6.9-8-12.3-17.3-15.9-27.4h-16.5c-6 0-11.2-4.3-12.2-10.3-2-12-2.1-24.6 0-37.1 1-6 6.2-10.4 12.2-10.4h16.5c3.6-10.1 9-19.4 15.9-27.4l-8.2-14.3c-3-5.2-1.9-11.9 2.8-15.7 9.5-7.9 20.4-14.2 32.1-18.6 5.7-2.1 12.1.1 15.1 5.4l8.2 14.3c10.5-1.9 21.2-1.9 31.7 0l8.2-14.3c3-5.3 9.4-7.5 15.1-5.4 11.8 4.4 22.6 10.7 32.1 18.6 4.6 3.8 5.8 10.5 2.8 15.7l-8.2 14.3c6.9 8 12.3 17.3 15.9 27.4h16.5c6 0 11.2 4.3 12.2 10.3 2 12 2.1 24.6 0 37.1-1 6-6.2 10.4-12.2 10.4h-16.5c-3.6 10.1-9 19.4-15.9 27.4l8.2 14.3c3 5.2 1.9 11.9-2.8 15.7-9.5 7.9-20.4 14.2-32.1 18.6-5.7 2.1-12.1-.1-15.1-5.4l-8.2-14.3c-10.4 1.9-21.2 1.9-31.7 0zM501.6 431c38.5 29.6 82.4-14.3 52.8-52.8-38.5-29.6-82.4 14.3-52.8 52.8z"
      fill="currentColor"
    />
  </svg>
);

export const downloadIcon = (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.38926 11.6191C9.40241 11.6359 9.41922 11.6495 9.43841 11.6589C9.45759 11.6682 9.47866 11.6731 9.5 11.6731C9.52134 11.6731 9.54241 11.6682 9.56159 11.6589C9.58078 11.6495 9.59759 11.6359 9.61074 11.6191L11.5795 9.12832C11.6516 9.03691 11.5865 8.90156 11.4688 8.90156H10.1662V2.95312C10.1662 2.87578 10.1029 2.8125 10.0256 2.8125H8.9709C8.89355 2.8125 8.83027 2.87578 8.83027 2.95312V8.8998H7.53125C7.41348 8.8998 7.34844 9.03516 7.42051 9.12656L9.38926 11.6191ZM15.9336 11.0039H14.8789C14.8016 11.0039 14.7383 11.0672 14.7383 11.1445V13.8516H4.26172V11.1445C4.26172 11.0672 4.19844 11.0039 4.12109 11.0039H3.06641C2.98906 11.0039 2.92578 11.0672 2.92578 11.1445V14.625C2.92578 14.9361 3.17715 15.1875 3.48828 15.1875H15.5117C15.8229 15.1875 16.0742 14.9361 16.0742 14.625V11.1445C16.0742 11.0672 16.0109 11.0039 15.9336 11.0039Z"
      fill="#003A70"
    />
  </svg>
);

export const swatch = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M4.098 19.902a3.75 3.75 0 005.304 0l6.401-6.402M6.75 21A3.75 3.75 0 013 17.25V4.125C3 3.504 3.504 3 4.125 3h5.25c.621 0 1.125.504 1.125 1.125v4.072M6.75 21a3.75 3.75 0 003.75-3.75V8.197M6.75 21h13.125c.621 0 1.125-.504 1.125-1.125v-5.25c0-.621-.504-1.125-1.125-1.125h-4.072M10.5 8.197l2.88-2.88c.438-.439 1.15-.439 1.59 0l3.712 3.713c.44.44.44 1.152 0 1.59l-2.879 2.88M6.75 17.25h.008v.008H6.75v-.008z"
    />
  </svg>
);

export const plus = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.9896 7.21875H8.78125V2.01042C8.78125 1.86654 8.66471 1.75 8.52083 1.75H7.47917C7.33529 1.75 7.21875 1.86654 7.21875 2.01042V7.21875H2.01042C1.86654 7.21875 1.75 7.33529 1.75 7.47917V8.52083C1.75 8.66471 1.86654 8.78125 2.01042 8.78125H7.21875V13.9896C7.21875 14.1335 7.33529 14.25 7.47917 14.25H8.52083C8.66471 14.25 8.78125 14.1335 8.78125 13.9896V8.78125H13.9896C14.1335 8.78125 14.25 8.66471 14.25 8.52083V7.47917C14.25 7.33529 14.1335 7.21875 13.9896 7.21875Z"
      fill="#262626"
    />
  </svg>
);

export const SignoutIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    stroke-width="1.5"
    stroke="currentColor"
    className="h-6 w-6"
  >
    <path
      stroke-linecap="round"
      stroke-linejoin="round"
      d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
    />
  </svg>
);
